import { handleActions } from 'redux-actions';
import {
  setTrialBalanceRowHighlight,
  clearTrialBalanceRowHighlight,
  deselectTrialBalanceRowHighlight,
  resetTrailBalanceWorkFlowStatus,
} from 'store/actions/trial-balance/trial-balance-action';
import { clearStatementPageStoreAction } from 'store/actions/statement-content-actions';
import SelectedElementMap from 'models/data/selected-element-map';

export default handleActions(
  {
    [setTrialBalanceRowHighlight]: (selectedElementMap, { payload }) => {
      return selectedElementMap.replaceWithoutRemovingOld(payload);
    },
    [clearTrialBalanceRowHighlight]: () => {
      return new SelectedElementMap();
    },
    [deselectTrialBalanceRowHighlight]: (selectedElementMap, { payload }) => {
      let result = selectedElementMap;
      payload.forEach((id) => {
        result = result.removeElement({ elementId: id });
      });
      return result;
    },
    [resetTrailBalanceWorkFlowStatus]: () => {
      return new SelectedElementMap();
    },
    [clearStatementPageStoreAction]: () => {
      return new SelectedElementMap();
    },
  },
  new SelectedElementMap(),
);
